// extracted by mini-css-extract-plugin
module.exports = {"confirmMessage":"sentCard_confirmMessage__DBTza","confirmWrapper":"sentCard_confirmWrapper__QT0PB"};